import React from "react";
import { Crosshair, ScanEye } from "lucide-react";
import { InspectorVisibilityEyeButton } from "../components/ui/InspectorVisibilityEyeButton";
import { InspectorVisibilitySection } from "../components/property-panels/InspectorVisibilitySection";
import VisibilityIconRow from "../components/property-panels/VisibilityIconRow";
import InertialScale from "../components/ui/InertialScale";
import { useInertialVisibilityControls } from "./useInertialVisibilityControls";
import { useViewerActions, useViewerStore } from "../stores/viewerStore";

const InertialVisibilityToolbar = ({
  inertialUuid,
  bodyUuid = null,
  className = "",
  sectionTitle = "Inertial Visibility",
}) => {
  const inertialVisibility = useViewerStore((s) => s.inertialVisibility);
  const showInertials = useViewerStore((s) => s.showInertials);
  const viewerActions = useViewerActions();
  const inertialKey = bodyUuid && inertialUuid ? `${bodyUuid}:${inertialUuid}` : inertialUuid;
  const thisInertialVisible = inertialKey ? (inertialVisibility[inertialKey] ?? true) : true;
  const { state, disabled, focusDisabled, toggleFocus, toggleOrientationAxes } =
    useInertialVisibilityControls({ inertialUuid, enabled: true });

  const buttons = [
    {
      key: "focus",
      title: "Display selected inertial only",
      on: state.focus,
      onClick: toggleFocus,
      disabled: focusDisabled,
      Icon: ScanEye,
    },
    {
      key: "orientation-axes",
      title: "Show orientation axes",
      on: state.orientationAxes,
      onClick: toggleOrientationAxes,
      disabled,
      Icon: Crosshair,
    },
  ];

  return (
    <InspectorVisibilitySection
      sectionTitle={sectionTitle}
      className={className}
      headerActions={
        <div className="flex items-center gap-1">
          <InspectorVisibilityEyeButton
            visible={thisInertialVisible}
            onToggle={() =>
              inertialKey && viewerActions.setInertialVisibility(inertialKey, !thisInertialVisible)
            }
            tooltipWhenOn="This inertial is visible — click to hide"
            tooltipWhenOff="This inertial is hidden — click to show"
            ariaLabel="Toggle this inertial's visibility"
          />
        </div>
      }
    >
      <VisibilityIconRow actions={buttons} />
      {showInertials ? <InertialScale /> : null}
    </InspectorVisibilitySection>
  );
};

export default React.memo(InertialVisibilityToolbar);
